import { Link, Navigate } from "react-router-dom";
import StudioIamSection from "../../../components/midpoint/clientViews/studio/StudioIamSection";
import { ClientViewIamApiProvider } from "../../../contexts/ClientViewIamApiContext";
import * as clientViewIamApi from "../../../api/clientViewIamApi";
import useMidpointMediaAdminView from "../../../hooks/useMidpointMediaAdminView";
import "../../../styles/clientViewStudio.css";
import "../../../styles/midpointMediaAdmin.css";

export default function MidpointMediaAdminPeopleAccountsPage() {
  const { clientViewId, permissions, paths } = useMidpointMediaAdminView();

  if (!clientViewId) {
    return <p className="empty-state">No workspace assigned.</p>;
  }
  if (!permissions?.manageIam && !permissions?.manageSettings) {
    return <Navigate to={paths.dashboard} replace />;
  }

  return (
    <div className="mm-admin-page">
      <header>
        <p className="mm-admin-kicker">
          <Link to={`${paths.base}/people`}>People</Link> · Accounts
        </p>
        <h1>Employee accounts</h1>
        <p className="mm-admin-lead">
          Invite teammates to Midpoint Media. They get access to CRM, people, infrastructure, and
          settings based on the role you assign.
        </p>
      </header>
      <ClientViewIamApiProvider api={clientViewIamApi}>
        <StudioIamSection clientViewId={clientViewId} canManage variant="portal" firmMode />
      </ClientViewIamApiProvider>
    </div>
  );
}
